import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../context/ProjectContext';

const STAGE_ORDER = ['collection', 'qa_review', 'reconciliation', 'final_delivery'];
const STAGE_LABELS = {
  collection: 'Collection',
  qa_review: 'QA Review',
  reconciliation: 'Reconciliation',
  final_delivery: 'Final Delivery',
};
const STAGE_REDIRECTS = {
  collection: '/',
  qa_review: '/qa',
  reconciliation: '/reconciliation',
  final_delivery: '/final-delivery',
};

/**
 * Wrap a page component to enforce workflow stage.
 * If the project hasn't reached `minStage`, redirects to the current stage's page.
 */
export default function StageGuard({ minStage, label, children }) {
  const { selected } = useProject();
  const navigate = useNavigate();
  const stage = selected?.workflow_stage || 'collection';
  const unlocked = STAGE_ORDER.indexOf(stage) >= STAGE_ORDER.indexOf(minStage);

  useEffect(() => {
    if (!unlocked) {
      const redirect = STAGE_REDIRECTS[stage] || '/';
      navigate(redirect, { replace: true });
    }
  }, [unlocked, stage, navigate]);

  if (!unlocked) {
    return (
      <div className="text-center py-20">
        <p className="text-gray-500">
          Complete {STAGE_LABELS[stage]} before accessing {label}.
        </p>
      </div>
    );
  }

  return children;
}
